import { RouteConfig } from 'vue-router';

const Shezhen = () => import(/* webpackChunkName: "Zsk" */  './modules/shezhen/shezhen.vue');
const ShezhenDetail = () => import(/* webpackChunkName: "Zsk" */  './modules/shezhen/shezhen-detail.vue');


const routers: RouteConfig[] = [
    {
        path: 'shezhen',
        component: Shezhen,
        meta: {
            keepAlive: true
        }
    },
    {
        path: 'shezhen-detail',
        component: ShezhenDetail
    },
    {
        path: '',
        redirect: 'shezhen'
    },
];

export default routers;
